import React, { useState } from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import JobDashboard from './OverviewSubComponent';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/Components/ui/button';
import { Heading } from '@/Components/ui/typography';
import { Sparkles } from 'lucide-react';
import { getColor } from '@/config/theme';
import { Can } from '@/HireWithUs/Context/CompanyAccessContext';

export const Overview = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isViewingApplications, setIsViewingApplications] = useState(() => {
    return searchParams.get('view') === 'applications' && !!searchParams.get('jobId');
  });

  return (
    <EmployerLayout>
      <div className="flex flex-col w-full gap-6">
        {/* Header - only show when not viewing applications */}
        {!isViewingApplications && (
          <div className="flex justify-between items-center">
            <Heading level="h4">Overview</Heading>
            <Can permission="jobs.create">
            <Button
              onClick={() => navigate('/hirewithus/postjob')}
              className="gap-2"
              style={{
                backgroundColor: getColor('primary'),
                color: getColor('primaryForeground'),
              }}
            >
              <Sparkles className="h-4 w-4" />
              Post a Job
            </Button>
            </Can>
          </div>
        )}
        
        <JobDashboard onViewChange={setIsViewingApplications} />
      </div>
    </EmployerLayout>
  );
};
